import { Panel, OriginTag } from "@/components/common/Primitives";
import { countryName, dateOnly, km, num } from "@/lib/format";

const Spec = ({ label, value }) => (
  <div className="border-b border-slate-100 px-3 py-1.5">
    <div className="label-xs">{label}</div>
    <div className="mono mt-0.5 text-[12.5px] text-slate-800">
      {value === null || value === undefined || value === "" ? (
        <span className="italic text-slate-400">Niet beschikbaar</span>
      ) : (
        value
      )}
    </div>
  </div>
);

export const GalleryPanel = ({ images, gallery, setGallery }) => (
  <Panel title="Fotogalerij" testid="gallery-panel">
    {(images || []).length === 0 ? (
      <div className="flex h-48 items-center justify-center border-b border-slate-100 text-[12px] italic text-slate-400">
        Geen foto's beschikbaar in de brondata
      </div>
    ) : (
      <>
        <img
          src={images[gallery]}
          alt=""
          className="h-64 w-full border-b border-slate-100 object-cover"
          data-testid="gallery-main-image"
        />
        <div className="flex gap-1.5 overflow-x-auto p-2">
          {images.map((url, i) => (
            <button
              key={url}
              type="button"
              onClick={() => setGallery(i)}
              className={`h-12 w-20 shrink-0 overflow-hidden rounded-sm border transition-colors duration-150 ${
                i === gallery ? "border-blue-600" : "border-slate-200"
              }`}
            >
              <img src={url} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      </>
    )}
  </Panel>
);

export const VehicleSpecsPanel = ({ listing }) => (
  <Panel title="Voertuig" actions={<OriginTag origin={listing.data_origin} />} testid="vehicle-panel">
    <div className="grid grid-cols-2 md:grid-cols-3">
      <Spec label="Merk" value={listing.make} />
      <Spec label="Model" value={listing.model} />
      <Spec label="Generatie" value={listing.generation} />
      <Spec label="Uitvoering" value={listing.variant} />
      <Spec label="Eerste toelating" value={dateOnly(listing.first_registration)} />
      <Spec label="Kilometerstand" value={km(listing.mileage_km)} />
      <Spec label="Brandstof" value={listing.fuel} />
      <Spec
        label="Vermogen"
        value={
          listing.power_hp || listing.power_kw
            ? `${listing.power_hp ? `${num(listing.power_hp)} pk` : ""}${
                listing.power_kw ? ` / ${num(listing.power_kw)} kW` : ""
              }`
            : null
        }
      />
      <Spec label="Transmissie" value={listing.transmission} />
      <Spec label="Kleur" value={listing.colour} />
      <Spec label="Carrosserie" value={listing.body_type} />
      <Spec label="Cilinderinhoud" value={listing.engine_cc ? `${num(listing.engine_cc)} cc` : null} />
      <Spec label="Verkoper" value={listing.seller_name || listing.seller_type} />
      <Spec label="Plaats" value={listing.city} />
      <Spec label="Land" value={countryName(listing.country)} />
      <Spec label="VIN" value={listing.vin} />
      <Spec label="CO₂ WLTP" value={listing.co2_wltp ? `${num(listing.co2_wltp)} g/km` : null} />
      <Spec label="CO₂ NEDC" value={listing.co2_nedc ? `${num(listing.co2_nedc)} g/km` : null} />
      <Spec
        label="BTW-status"
        value={listing.vat_status === "Onbekend" ? "Controle vereist" : listing.vat_status}
      />
      <Spec label="Bron" value={listing.source} />
      <Spec label="Advertentie geplaatst" value={dateOnly(listing.listed_at)} />
    </div>
    {(listing.equipment || []).length > 0 && (
      <div className="border-t border-slate-100 p-3">
        <div className="label-xs mb-1.5">Opties / uitrusting</div>
        <div className="flex flex-wrap gap-1">
          {listing.equipment.map((e) => (
            <span key={e} className="chip border-slate-300 bg-slate-50 text-slate-600">
              {e}
            </span>
          ))}
        </div>
      </div>
    )}
  </Panel>
);
